import { CreateUploadConsentFormSchema } from 'commons/auditionForm';
import { useTranslationWithLang } from 'hooks/useTranslationWithLang';

// 多言語対応のためスキーマをフック化
export const useUploadConsentFormSchema = (
  representative: boolean,
  terms_file_required: string,
  privacy_notice_file_required: string,
  specific_use_file_required: string
) => {
  const { t } = useTranslationWithLang('auditionForm');

  const schema = CreateUploadConsentFormSchema(
    {
      RequiredMessage: t('Validate_Required'),
      MinLengthMessage: (min: number) => t('Validate_MinLength', { min }),
      MaxLengthMessage: (max: number) => t('Validate_MaxLength', { max }),
      FileRequiredMessage: t('Validate_File_Required'),
      FileSizeMessage: t('Validate_File_Size'),
      PhoneNumberMessage: t('Validate_PhoneNumber'),
      FileExtensionMessage: t('Validate_File_Extension'),
    },
    representative,
    terms_file_required,
    privacy_notice_file_required,
    specific_use_file_required
  );
  return schema;
};
